import { sqliteTable, text, integer, real } from "drizzle-orm/sqlite-core";
import { rentalBookings } from "./rental-bookings";
import { rentalPickups } from "./rental-pickups";

// ============================================================================
// rental_returns — เอกสารคืนรถ
// ============================================================================
export const rentalReturns = sqliteTable("car_rental_rental_returns", {
  id: text("id").primaryKey(), // ULID
  returnNo: text("return_no").notNull().unique(),
  bookingId: text("booking_id").notNull().references(() => rentalBookings.id), // FK → rental_bookings
  pickupId: text("pickup_id").notNull().references(() => rentalPickups.id), // FK → rental_pickups
  returnDatetime: text("return_datetime").notNull(),
  receivedBy: text("received_by"), // FK → users
  returnedBy: text("returned_by"), // ผู้ส่งคืน (ชื่อ)
  odometerReading: real("odometer_reading"),
  fuelLevel: text("fuel_level", {
    enum: ["empty", "1/4", "1/2", "3/4", "full"],
  }),
  exteriorCondition: text("exterior_condition"),
  interiorCondition: text("interior_condition"),
  totalPenalty: real("total_penalty").notNull().default(0),
  penaltyRemarks: text("penalty_remarks"),
  refundAmount: real("refund_amount").notNull().default(0),
  returnRemarks: text("return_remarks"),
  status: text("status", {
    enum: ["submitted", "cancelled"],
  }).notNull().default("submitted"),
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
});

export type RentalReturn = typeof rentalReturns.$inferSelect;
export type NewRentalReturn = typeof rentalReturns.$inferInsert;
